import React from 'react';
import { Box, Typography } from '@material-ui/core';

export function StripeAuthorizationCallback() {
  // Since Stripe doesn't use OAuth callbacks, this is a simple success message
  return (
    <Box>
      <Box p={2} style={{ backgroundColor: '#e8f5e8', borderRadius: '4px', border: '1px solid #4caf50' }}>
        <Typography variant='body2' style={{ color: '#2e7d32' }}>
          Stripe integration has been successfully configured. You can now create payment tasks for volunteers.
        </Typography>
      </Box>
    </Box>
  );
}
